import { useMemo } from 'react';
import { useQueries } from 'react-query';
import { useGroundTruths } from './useGroundTruths';
import { GroundTruthFilters } from 'services/api/aiReviewTest/groundTruthApi';
import { fetchPatientById } from 'api/patientService';

export const useGroundTruthsWithPatients = (filters?: GroundTruthFilters) => {
  const { groundTruths, isLoading: isLoadingGT, ...rest } = useGroundTruths(filters);
  
  console.log('useGroundTruthsWithPatients - received groundTruths:', groundTruths);
  
  // 중복 제거한 환자 ID 목록
  const patientIds = useMemo(() => {
    if (!groundTruths || !Array.isArray(groundTruths)) return [];
    const ids = groundTruths.map(gt => gt.patientId);
    return Array.from(new Set(ids));
  }, [groundTruths]);

  // 필요한 환자 정보만 조회 (React Query가 자동 캐싱)
  const patientsQueries = useQueries(
    patientIds.map(id => ({
      queryKey: ['patients', id],
      queryFn: () => fetchPatientById(id),
      staleTime: 10 * 60 * 1000, // 10분
    }))
  );

  // 데이터 조합
  const groundTruthsWithPatients = useMemo(() => {
    if (!groundTruths || !Array.isArray(groundTruths)) return [];
    
    const patientsMap = patientsQueries
      .filter(q => q.data)
      .reduce((acc, q) => {
        if (q.data?.data) {
          acc[q.data.data.id] = q.data.data;
        }
        return acc;
      }, {} as Record<number, any>);
    
    return groundTruths.map(gt => ({
      ...gt,
      patient: patientsMap[gt.patientId] || null,
    }));
  }, [groundTruths, patientsQueries]);

  const isLoading = isLoadingGT || patientsQueries.some(q => q.isLoading);

  console.log('useGroundTruthsWithPatients - returning:', groundTruthsWithPatients);
  
  return {
    ...rest,
    groundTruths: groundTruthsWithPatients,
    isLoading,
  };
};